/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: Aumentados (https://sketchfab.com/minego90)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/deadpool-lego-70445bc5c98d4ab3a114732cf6555707
Title: Deadpool Lego
*/

import React, { useEffect, useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import { useFrame } from '@react-three/fiber';
import scene from '../assets/3d/deadpool.glb'

export default function Deadpool({animate, ...props}) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF(scene)
  const { actions } = useAnimations(animations, group)

  useEffect(() => { 
    console.log('animate', animate)
    if (animate === 2) { 
        actions['CINEMA_4D_Principal'].play();
    }
  }, [animate, actions])

  useFrame((state, delta) => {
    if (animate === 1) {
      group.current.rotation.y += delta;
    }
    if (animate === 2) {
      group.current.rotation.y -= delta*15;
    }
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Sketchfab_Scene">
        <group
          name="Sketchfab_model"
          rotation={[-Math.PI / 2, 0, 0]}
          userData={{ name: 'Sketchfab_model' }}>
          <group
            name="0ce1f9151b544c88bac680099095cd28fbx"
            rotation={[Math.PI / 2, 0, 0]}
            userData={{ name: '0ce1f9151b544c88bac680099095cd28.fbx' }}>
            <group name="Object_2" userData={{ name: 'Object_2' }}>
              <group name="RootNode" userData={{ name: 'RootNode' }}>
                <group name="Null_1" userData={{ name: 'Null_1' }}>
                  <group
                    name="body"
                    position={[0, 153.56, 0]}
                    rotation={[0.002, 0, 0]}
                    userData={{ name: 'body' }}>
                    <mesh
                      name="body_Mat_0"
                      castShadow
                      receiveShadow
                      geometry={nodes.body_Mat_0.geometry}
                      material={materials.material}
                      userData={{ name: 'body_Mat_0' }}
                    />
                    <group
                      name="vaina"
                      position={[0, 244.763, 26.438]}
                      userData={{ name: 'vaina' }}>
                      <mesh
                        name="vaina_Mat4_0"
                        castShadow
                        receiveShadow
                        geometry={nodes.vaina_Mat4_0.geometry}
                        material={materials['Mat.4']}
                        userData={{ name: 'vaina_Mat.4_0' }}
                      />
                      <group
                        name="katana1"
                        position={[-86.6, 27.801, 55.312]}
                        rotation={[Math.PI / 2, -Math.PI / 4, -Math.PI / 2]}
                        userData={{ name: 'katana1' }}>
                        <mesh
                          name="katana1_Mat4_0"
                          castShadow
                          receiveShadow
                          geometry={nodes.katana1_Mat4_0.geometry}
                          material={materials['Mat.4']}
                          userData={{ name: 'katana1_Mat.4_0' }}
                        />
                        <mesh
                          name="katana1_Mat4_1_0"
                          castShadow
                          receiveShadow
                          geometry={nodes.katana1_Mat4_1_0.geometry}
                          material={materials['Mat.4_1']}
                          userData={{ name: 'katana1_Mat.4_1_0' }}
                        />
                      </group>
                      <group
                        name="katana2"
                        position={[88.853, 27.801, 55.312]}
                        rotation={[Math.PI / 2, Math.PI / 4, Math.PI / 2]}
                        userData={{ name: 'katana2' }}>
                        <mesh
                          name="katana2_Mat4_0"
                          castShadow
                          receiveShadow
                          geometry={nodes.katana2_Mat4_0.geometry}
                          material={materials['Mat.4']}
                          userData={{ name: 'katana2_Mat.4_0' }}
                        />
                        <mesh
                          name="katana2_Mat4_1_0"
                          castShadow
                          receiveShadow
                          geometry={nodes.katana2_Mat4_1_0.geometry}
                          material={materials['Mat.4_1']}
                          userData={{ name: 'katana2_Mat.4_1_0' }}
                        />
                      </group>
                    </group>
                    <group name="legL" position={[0, -153.56, 0]} userData={{ name: 'legL' }} />
                    <group
                      name="legR"
                      position={[50.781, 0.993, -2.698]}
                      rotation={[-0.017, 0, Math.PI / 2]}
                      userData={{ name: 'legR' }}
                    />
                    <group
                      name="Root"
                      position={[0.82, -2.101, 0.315]}
                      rotation={[0, Math.PI / 2, 0]}
                      userData={{ name: 'Root' }}>
                      <group name="Object_18" userData={{ name: 'Object_18' }}>
                        <primitive object={nodes._rootJoint} />
                        <skinnedMesh
                          name="Object_21"
                          geometry={nodes.Object_21.geometry}
                          material={materials.Mat_1}
                          skeleton={nodes.Object_21.skeleton}
                          userData={{ name: 'Object_21' }}
                        />
                        <skinnedMesh
                          name="Object_23"
                          geometry={nodes.Object_23.geometry}
                          material={materials.Mat_2}
                          skeleton={nodes.Object_23.skeleton}
                          userData={{ name: 'Object_23' }}
                        />
                        <skinnedMesh
                          name="Object_45"
                          geometry={nodes.Object_45.geometry}
                          material={materials['Mat.1']}
                          skeleton={nodes.Object_45.skeleton}
                          userData={{ name: 'Object_45' }}
                        />
                        <skinnedMesh
                          name="Object_47"
                          geometry={nodes.Object_47.geometry}
                          material={materials['Mat.1']}
                          skeleton={nodes.Object_47.skeleton}
                          userData={{ name: 'Object_47' }}
                        />
                        <group
                          name="Object_20"
                          position={[-51.049, 154.576, 0]}
                          rotation={[0, 0, Math.PI / 2]}
                          userData={{ name: 'Object_20' }}
                        />
                        <group
                          name="Object_22"
                          position={[50.781, 154.553, -2.698]}
                          rotation={[-0.017, 0, Math.PI / 2]}
                          userData={{ name: 'Object_22' }}
                        />
                        <group
                          name="Object_44"
                          position={[-42.37, 49.215, 0]}
                          userData={{ name: 'Object_44' }}
                        />
                        <group
                          name="Object_46"
                          position={[50, 49.215, 0]}
                          userData={{ name: 'Object_46' }}
                        />
                      </group>
                    </group>
                    <group name="head" position={[0, 241.385, 0]} userData={{ name: 'head' }}>
                      <mesh
                        name="head_Mat5_0"
                        castShadow
                        receiveShadow
                        geometry={nodes.head_Mat5_0.geometry}
                        material={materials['Mat.5']}
                        userData={{ name: 'head_Mat.5_0' }}
                      />
                    </group>
                    <group
                      name="body_axis"
                      position={[50.895, 86.706, 0.043]}
                      rotation={[0, -0.001, 0]}
                      userData={{ name: 'body_axis' }}>
                      <mesh
                        name="body_axis_Mat3_0"
                        castShadow
                        receiveShadow
                        geometry={nodes.body_axis_Mat3_0.geometry}
                        material={materials['Mat.3']}
                        userData={{ name: 'body_axis_Mat.3_0' }}
                      />
                    </group>
                    <group
                      name="arm_I"
                      position={[105.9, 194.319, -3.085]}
                      rotation={[2.759, 0, -Math.PI]}
                      userData={{ name: 'arm_I' }}
                    />
                    <group
                      name="arm_D"
                      position={[-78.785, 194.319, -3.085]}
                      rotation={[2.759, 0, -Math.PI]}
                      userData={{ name: 'arm_D' }}
                    />
                  </group>
                </group>
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

